import { useEffect, useState } from "react";

// Api
import { GetFilms } from "../../../../Api/Video";

// Models
import ICarouselContentDTO from "../../../../Models/DTOs/ICarouselContentDTO";

// Helpers
import {transformVideoToCarouselContent} from "../../../../Helpers/DataConversion/ConvertToCarouselContentItem";

function useFetchFilms(
    take: number,
    skip: number,
    shouldAppendData: boolean
) {
    const
        [films, setFilms] = useState<ICarouselContentDTO[]>([]),
        [filmsLoading, setFilmsLoading] = useState(false),
        [filmsError, setFilmsError] = useState("");

    useEffect(() => {
        let isCancelled = false;

        setFilmsLoading(true);
        setFilmsError("");

        (async () => {
            try {
                const data = await GetFilms({ take, skip }); // CountWrapper<VideoDTO>

                if (isCancelled) return;

                const transformed = (data.items ?? []).map(transformVideoToCarouselContent);

                if (shouldAppendData) {
                    setFilms((prev) => [...prev, ...transformed]);
                } else {
                    setFilms(transformed);
                }
            } catch (err) {
                if (!isCancelled) {
                    console.error(err);
                    setFilmsError("Failed to fetch films.");
                }
            } finally {
                if (!isCancelled) {
                    setFilmsLoading(false);
                }
            }
        })();

        return () => {
            isCancelled = true;
        };
    }, [take, skip, shouldAppendData]);

    return { films, filmsLoading, filmsError };
}

export default useFetchFilms;
